// src/components/blog/BlogHeader.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logo from "../../assets/logo-applaby.png";

export default function BlogHeader() {
	const [scrolled, setScrolled] = useState(false);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 8);
		onScroll(); // evaluar al cargar
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<header
			className={`fixed top-0 left-0 w-full z-50 transition-all duration-300
        ${
					scrolled
						? "bg-white/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 shadow-sm border-b border-gray-100"
						: "bg-white shadow-sm border-b border-gray-100"
				}`}
		>
			<div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
				{/* Logo */}
				<Link to="/" className="flex items-center gap-2">
					<img src={logo} alt="Applaby" className="h-8" />
				</Link>

				{/* Nav desktop */}
				<nav className="hidden md:flex items-center gap-6 text-sm font-medium text-gray-600">
					<a href="/" className="hover:text-[#43BD98] transition">
						Inicio
					</a>
					<a href="/#precios" className="hover:text-[#43BD98] transition">
						Precios
					</a>
					<a href="/#contacto" className="hover:text-[#43BD98] transition">
						Contacto
					</a>
					<Link to="/blog" className="hover:text-[#43BD98] transition">
						Blog
					</Link>
				</nav>

				{/* Toggle móvil */}
				<button
					onClick={() => setOpen(!open)}
					className="md:hidden inline-flex items-center justify-center w-10 h-10 rounded-lg border border-gray-200"
					aria-label="Abrir menú"
				>
					{open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
				</button>
			</div>

			{/* Menú móvil */}
			{open && (
				<div className="md:hidden bg-white border-t border-gray-100 shadow-sm">
					<div className="max-w-6xl mx-auto px-6 py-3 flex flex-col gap-3 text-gray-700 text-sm">
						<a href="/" onClick={() => setOpen(false)} className="py-2">
							Inicio
						</a>
						<a href="/#precios" onClick={() => setOpen(false)} className="py-2">
							Precios
						</a>
						<a
							href="/#contacto"
							onClick={() => setOpen(false)}
							className="py-2"
						>
							Contacto
						</a>
						<Link to="/blog" onClick={() => setOpen(false)} className="py-2">
							Blog
						</Link>
					</div>
				</div>
			)}
		</header>
	);
}
